import React from 'react';
import { Navigate, useParams } from 'react-router';
import useUserData from '../../Hooks/use-user-data';
import { useMsal } from '@azure/msal-react';
import { Center, Loader } from '@mantine/core';

type PropType = React.PropsWithChildren & {
  redirectPath?: string;
  paramName?: string;
};

const ProtectedRoute = ({ children, redirectPath = '/', paramName }: PropType) => {
  const { loggedIn } = useUserData();
  const { inProgress } = useMsal();
  const params = useParams();

  if (inProgress === 'none') {
    if (!loggedIn) {
      if (paramName && params[paramName]) {
        redirectPath += params[paramName];
      }
      return <Navigate to={redirectPath} replace />;
    } else {
      return children as JSX.Element;
    }
  }
  return (
    <Center style={{ height: '100%' }}>
      <Loader color="blue" size="xl" />;
    </Center>
  );
};

export default ProtectedRoute;
